import { useState } from 'react';
import { cx } from '@/lib/cx';
import { useT } from '@/i18n/LocaleProvider';
import styles from './AuthScreen.module.css';

interface Props {
  id: string;
  label: string;
  /** Подсказка справа от подписи («8+ characters»). */
  hint?: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  autoComplete: 'current-password' | 'new-password';
  className?: string;
  disabled?: boolean;
}

/** Одно поле пароля с переключателем SHOW / HIDE (AUTH-2, AUTH-3). */
export function PasswordField({
  id,
  label,
  hint,
  value,
  onChange,
  error,
  autoComplete,
  className,
  disabled,
}: Props) {
  const [visible, setVisible] = useState(false);
  const t = useT();
  return (
    <label className={cx(styles.field, className)} htmlFor={id}>
      <span className={styles.label}>
        {label}
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </span>
      <span className={styles.passwordWrap}>
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          className={cx(styles.input, styles.passwordInput, error && styles.inputError)}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="••••••••"
          autoComplete={autoComplete}
          disabled={disabled}
          aria-invalid={error || undefined}
        />
        <button
          type="button"
          className={styles.toggle}
          onClick={() => setVisible((v) => !v)}
          aria-pressed={visible}
          aria-label={t(visible ? 'auth.hidePassword' : 'auth.showPassword')}
        >
          {t(visible ? 'auth.hide' : 'auth.show')}
        </button>
      </span>
    </label>
  );
}
